import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { getProfileState } from '@/profile/stores/store'
interface MenuProps {
  name: string
  icon: string
  link: string
  service ?: string
  group ?:string
  scopes?: String[]
  suffix?: string | ReactNode
  children?: MenuProps[]
  roles?: String[]
  code: string
}

const PORTAL_PREFIX = '/admin'
export const menu: MenuProps[] = [
  {
    icon: 'contact_card_regular',
    service : 'admin',
    group: 'adminManagement',
    name: 'title',
    link: `${PORTAL_PREFIX}/user`,
    code: 'USER_ADMIN_MANAGEMENT'
  },
  {
    icon: 'lock_closed_regular',
    service : 'admin',
    group: 'roleManagement',
    name: 'title',
    link: `${PORTAL_PREFIX}/role`,
    code: 'ROLE_MANAGEMENT'
  },
  {
    icon: 'checkmark_lock_regular',
    service : 'admin',
    group: 'permissionManagement',
    name: 'title',
    link: `${PORTAL_PREFIX}/permission`,
    code: 'PERMISSION_MANAGEMENT'
  },
  {
    icon: 'text_grammar_settings_regular',
    service : 'admin',
    group: 'resourceManagement',
    name: 'title',
    link: `${PORTAL_PREFIX}/resource`,
    code: 'RESOURCE_MANAGEMENT'
  }
]

export const getMenu = () => {
  const profile = useSelector(getProfileState)
  const codeAccess = new Set<string>()
  profile?.roles?.forEach((role) => role.resources?.forEach((resource) => codeAccess.add(resource.code || '')))

  const filterMenu = menu.filter((item) => codeAccess.has(item.code))
  return filterMenu
}
